export enum FlightOfferViewEnum {
  DETAILS = 'DETAILS',
  PAYMENT = 'PAYMENT',
  COMPLETED = 'COMPLETED',
}
